import { render, staticRenderFns } from "./re-candidate-interview.vue?vue&type=template&id=98b3e1f8&scoped=true"
import script from "./re-candidate-interview.vue?vue&type=script&lang=ts"
export * from "./re-candidate-interview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b3e1f8",
  null
  
)

export default component.exports